module.exports = __webpack_public_path__ + "fonts/Mount-Bold.269de58.woff";